import { IComponentOptions } from 'angular';
import { RastreamentoDetalhesController } from './rastreamento-detalhes.controller';

/**
 * @type {IComponentOptions}
 */
export const RastreamentoDetalhesComponent = {
  controller: RastreamentoDetalhesController,
  controllerAs: '$ctrl',
  template: require('./rastreamento-detalhes.component.html'),
  bindings: {
    encomenda: '<',
    addAlert: '<',
    onEmailSent: '<',
  }
};
